const types = {
  GET_COLLECTIONS_START: 'GET_COLLECTIONS_START',
  GET_COLLECTIONS_SUCCESS: 'GET_COLLECTIONS_SUCCESS',
  GET_COLLECTIONS_FAILURE: 'GET_COLLECTIONS_FAILURE',
  GET_COLLECTION_DETAILS_START: 'GET_COLLECTION_DETAILS_START',
  GET_COLLECTION_DETAILS_SUCCESS: 'GET_COLLECTION_DETAILS_SUCCESS',
  GET_COLLECTION_DETAILS_FAILURE: 'GET_COLLECTION_DETAILS_FAILURE',
  GET_COLLECTIONS_PAGES_SUCCESS: 'GET_COLLECTIONS_PAGES_SUCCESS',
  GET_COMPANY_COLLECTIONS_SUCCESS: 'GET_COMPANY_COLLECTIONS_SUCCESS',
};
export default types;
